import getUserAndClientsFromStorage from '../utils/getUserAndClientsFromStorage';

const { user, clients } = getUserAndClientsFromStorage();

const initialState = {
    user: {
        isLoggedIn: false,
        isLoading: false,
        isRequestingLink: false,
        isSelectingClient: false,
        selectedClientId: null,
        selectedUserClientId: null,
        error: { message: null },
        clients: [],
        overrides: { primaryColor: '', secondaryColor: '' },
        cubeToken: null,
        userPreferences: {
            rightsholder_attribution: '',
        },
        ...user,
    },
    clients: { ...clients },
};

export default initialState;
